// extracted by mini-css-extract-plugin
export default {"fullPageBackground":"_5WGrv7CKIqTmotH06HPI5i","modalScrollContainer":"_3Bef3NVPA0wBDcSJVNzFOU","fakeFullHeightBackground":"_2ciGfbLvXzBB7386y0LWAJ"};